import { render, staticRenderFns } from "./AssetHistory.vue?vue&type=template&id=794b2614&"
import script from "./AssetHistory.vue?vue&type=script&lang=ts&"
export * from "./AssetHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('794b2614')) {
      api.createRecord('794b2614', component.options)
    } else {
      api.reload('794b2614', component.options)
    }
    module.hot.accept("./AssetHistory.vue?vue&type=template&id=794b2614&", function () {
      api.rerender('794b2614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Reports/AssetHistory.vue"
export default component.exports